const getPermissionCheckStatus = state => state?.checkPermission?.status;
const getPermittedPermissions = state => state?.checkPermission?.permittedPermissions;
const getIsPermissionChecked = state => state?.checkPermission?.isPermissionChecked;

export { getPermissionCheckStatus, getPermittedPermissions, getIsPermissionChecked };
